import cacheLs from "../cacheLs"

export default {
  addUserInterest (state, data) {
    state.selectedUserInterest = { ...data }
    cacheLs.set_user_interest(data)
  }
}
